import { createAction } from '@reduxjs/toolkit';

import { HealthActions } from '../constants/health';

export const createGetPingAction = () => createAction(HealthActions.GetPing);